import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.expenses')
  .factory('ExpensesCategoriesApi', ExpensesCategoriesApi);

function ExpensesCategoriesApi(): BringozApi {
  return {
    base: `/expenses/category`,
    infiniteScroll: {
      address: `/expenses/category`,
      cmd: 'GET'
    },
    actions: {
      createCategory: {
        address: '',
        cmd: 'PUT',
        updateable: true
      },
      updateCategory: {
        address: '{id}',
        cmd: 'POST',
        updateable: true
      },
      archiveCategory: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: true
      }
    }
  }
}
